import { Col, Label, ReactSelectBox } from "client/CommonComponents";

const Snow = (props?: any) => {
  const managedEquipmentValues = props?.managedEquipmentValues;
  const manufacturerDropDownList  = props?.manufacturerDropDownList;
  const categoryDropdownList = props?.categoryDropdownList;
  const SizeDropDownList = props?.SizeDropDownList;
  const TypeDropDownList = props?.TypeDropDownList;
  const managedEquipRef = props?.managedEquipRef;
  const handleManufacturerChange = props?.handleManufacturerChange;
  const handleCategoryChange = props?.handleCategoryChange;
  const handleSizeChange = props?.handleSizeChange;
  const handleTypeChange = props?.handleTypeChange;

  return (<>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Snow_Default_Label">Manufacturer</Label>
        <ReactSelectBox
          options={manufacturerDropDownList}
          onChange={(item: any, e: any) => handleManufacturerChange(e, item,'manufacturer')}
          value={managedEquipmentValues?.manufacturer}
          selectRef={(element:any)=> managedEquipRef.current[1] = element}
          isSearchable={true}
         data-attribute="Snow_Default_SearchSelectBox" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Snow_Default_Label_2">Category</Label>
        <ReactSelectBox
          options={categoryDropdownList}
          onChange={(item: any, e: any) => handleCategoryChange(e, item,'category')}
          value={managedEquipmentValues?.category}
          selectRef={(element:any)=> managedEquipRef.current[2] = element}
          isSearchable={true}
         data-attribute="Snow_Default_SearchSelectBox_2" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="Snow_Default_Label_3">Size</Label>
          <ReactSelectBox
            options={SizeDropDownList}
            onChange={(item: any, e: any) => handleSizeChange(e, item,'size')}
            value={managedEquipmentValues?.size}
            selectRef={(element:any)=> managedEquipRef.current[3] = element}
            isSearchable={true}
           data-attribute="Snow_Default_SearchSelectBox_3" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="Snow_Default_Label_4">Type</Label>
          <ReactSelectBox
            options={TypeDropDownList}
            onChange={(item: any, e: any) => handleTypeChange(e, item,'type')}
            value={managedEquipmentValues?.type}
            selectRef={(element:any)=> managedEquipRef.current[4] = element}
            isSearchable={true}
           data-attribute="Snow_Default_SearchSelectBox_4" />
        </Col>
          </>)
}

export default Snow;
